import firebase from 'firebase';
import router from '@/router';
import { gettagletters, callcloudfunction, extendedtagnumber, nowmonth } from '@/functions.js';

export default{

    mutations: {
        changedUserCore(state, payload) {
            //alert("users.js changedUserCore " + payload);
            this.state.currentuser = payload;
            this.state.databaseid = this.state.currentuser.DatabaseID;
            this.dispatch('listenForContacts', false);
            this.dispatch('listenForGroups', false);
            this.dispatch('listenForSurveys', false);
            this.dispatch('listenForShares', false);
            this.dispatch('listenForTags', false);
        },
        changedUserAccount(state, payload) {
            this.state.useraccount = payload;
            //need to check that bandwidth and mediasize are within plan limits
            if (this.state.useraccount.usage.Month != this.state.currentmonth) {
                var pln = this.state.useraccount.billing.Plan;
                var billing = { Bandwidth: this.state.useraccount.usage.Bandwidth, Media: this.state.useraccount.usage.MediaSize, Plan: pln };
                firebase.database().ref('useraccounts/' + this.state.user.uid + "/billing/History/" + this.state.useraccount.usage.Month).set(billing);
                this.state.useraccount.usage.Bandwidth = 0;
                this.state.useraccount.usage.Month = this.state.currentmonth;
                firebase.database().ref('useraccounts/' + this.state.user.uid + "/usage").set(this.state.useraccount.usage);
            }
        },
        setUser(state, payload) {
            this.state.user = payload;
            this.dispatch('listenForUser', false);
        },
        addUser(state, payload) {
            this.state.user = payload.user;
            //alert('addUser ' + payload.name);
            this.dispatch('userAdd', payload);
        },
        checkInvites(state, payload) {
            //alert('checkInvites');
            this.dispatch('checkInvite', { email: this.state.currentuser.Email, db: this.state.currentuser.DatabaseID, uid: this.state.user.uid });           
        },
        setMode(state, payload) {
            this.state.mode = payload;
        },
        setIsAuthenticated(state, payload) {
            if (payload) {
                this.state.isAuthenticated = "true";
            }
            else {
                this.state.isAuthenticated = "false";
            }
        },
        setInitialChecked(state, payload) {
            this.state.initialChecked = payload;
        }
    },
    actions: {
        userAdd(state, udata) {
            //alert("userAdd in users.js " + udata.name);
            this.state.tagletters = gettagletters(udata.name);
            this.state.udata = udata;
            callcloudfunction("checkTag", "initials", { tagletters: this.state.tagletters }, this, "tagChecked");   
            callcloudfunction("sendMail", "welcome", { name: udata.name, email:udata.email }, this, "");   
        },
        tagChecked(state, res) {
            var udata = this.state.udata;
            //alert("tagChecked " + this.state.tagletters + " " + res);
            var arr = res.split(",");
            var tagletters = this.state.tagletters + "01";
            if (arr[1] != "error") {
                var etn = extendedtagnumber(arr[1]);
                tagletters = this.state.tagletters + etn;
            }
            alert("Your tag has been auto-selected as " + tagletters + ". Go to Settings to change it.");

            var uaccount = { billing: { Plan: "Free" }, usage: { Bandwidth: 0, MediaCount: 0, MediaSize: 0, Month:nowmonth() } };
            var ucore = { Email: udata.email, Name: udata.name, DatabaseID: "-M7q-sJplMQbYiPZOX6V", Organisation: "-No Organisation", Tag: tagletters, AlertEmail:"2", SurveyEmail:"1" };
            firebase.database().ref('useraccounts/' + udata.user.user.uid).set(uaccount);
            firebase.database().ref('usercore/' + udata.user.user.uid).set(ucore);
            this.commit('checkInvites', udata);
        },
        userLogin({ commit }, { email, password }) {
            //alert("userLogin");
            firebase
                .auth()
                .signInWithEmailAndPassword(email, password)
                .then(user => {
                    commit('setUser', user);
                    commit('setIsAuthenticated', true);
                    router.push('/about');
                })
                .catch(() => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    router.push('/');
                });
        },
        userJoin({ commit }, { name, email, password }) {
            //alert("userJoin");
            firebase
                .auth()
                .createUserWithEmailAndPassword(email, password)
                .then(user => {
                    commit('addUser', { user: user, name: name, email:email });
                    commit('setIsAuthenticated', true);
                    router.push('/about');
                })
                .catch(() => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    router.push('/');
                });
        },
        userSignOut({ commit }) {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    router.push('/');
                })
                .catch(() => {
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    router.push('/');
                });
        }
    }
}